import React, { useState } from 'react'
import styles from './btnCall.module.scss'
import cn from 'classnames'
import AskAboutPuppyModal from './AskAboutPuppyModal'

export default function ButtonAsk ({ special, dataPuppy }) {
  const [openModal, setOpenModal] = useState(false)
  return (
    <>
      <button
        onClick={() => setOpenModal(true)}
        className={cn({ [styles.btnAsk]: true, [styles.special]: special })}
      >
        <div className={styles.chat} />
        <div className={styles.containerText}>
          <span className={styles.title}>Ask about this puppy</span>
        </div>
      </button>
      <AskAboutPuppyModal
        dataPuppy={dataPuppy}
        isOpen={openModal}
        close={() => {
          setOpenModal(false)
        }}
      />
    </>
  )
}
